module.exports = __webpack_public_path__ + "img/5204.539c28c8.png";